module.exports = __webpack_public_path__ + "my.svg?789a6ddf349312be499c1b20096b0240";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/my.svg
// module id = 1269
// module chunks = 0